import React, { useState } from 'react';
import { ThemeProvider } from '@mui/system';
import { Tooltip, IconButton } from '@mui/material';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

import * as DefaultRoutes from '@Routes/DefaultRoutes';
import { ALL_SUBMITTED_EXEMPTION_REQUESTS } from '@API/APIRoutes';
import GenericRnDListing from '@Pages/RnDMember/GenericRnDListing/GenericRnDListing';
import { buildExemptionColumns, DEFAULT_EXEMPTION_COLUMN_VISIBILITY } from './exemptionColumns';

const PAGE_TITLE = 'Regulatory Exemptions Hub';
const ERROR_MESSAGE = 'Failed to fetch exemption requests. Trying again!';
const TOOLTIP_VIEW_DETAILS = 'Open Exemption Request';

/**
 * The Approver's Regulatory Exemptions Hub: every submitted exemption request, whether or not the
 * approver is enrolled on it, server-paginated and filterable. Read-only; decisions are taken from
 * "Exemptions to Approve" or the request page, which only enrolled approvers can act on.
 */
function AllExemptionsListing() {
  const [rows, setRows] = useState([]);
  const columns = buildExemptionColumns();

  const renderActions = (params, navigate, theme) => (
    <ThemeProvider theme={theme}>
      <Tooltip title={TOOLTIP_VIEW_DETAILS}>
        <IconButton
          color="info"
          size="small"
          onClick={() => navigate(DefaultRoutes.exemptionInfo.replace(':planId', params.row.id))}
        >
          <LightbulbOutlinedIcon />
        </IconButton>
      </Tooltip>
    </ThemeProvider>
  );

  return (
    <GenericRnDListing
      pageTitle={PAGE_TITLE}
      PageIcon={<ReceiptLongIcon color="white" fontSize="large" />}
      iconColor="warning.main"
      apiRoute={ALL_SUBMITTED_EXEMPTION_REQUESTS}
      columns={columns}
      renderActions={renderActions}
      errorMessage={ERROR_MESSAGE}
      initialColumnVisibilityModel={DEFAULT_EXEMPTION_COLUMN_VISIBILITY}
      serverPagination={true}
      rows={rows}
      setRows={setRows}
      getRowId={(row) => row.id}
    />
  );
}

export default AllExemptionsListing;
